import React, { useCallback } from "react";
import { FacebookProvider, Login } from "react-facebook";
import { APP_ID, SCOPE } from "../../../../cores/instagram/config";

interface InstagramProviderResponse {
  tokenDetail: { accessToken: string };
}

interface ButtonProps {
  className?: string;
  children: React.ReactNode;
  onCompleted: (accessToken: string) => void;
  onError?: (error: string) => void;
}

/**
 * Botón visible que dispara Facebook Login en el mismo gesto del usuario (requerido para OAuth).
 */
export function InstagramFacebookConnectButton({
  className,
  children,
  onCompleted,
  onError,
}: ButtonProps) {
  const handleOnCompleted = useCallback(
    ({ tokenDetail: { accessToken } }: InstagramProviderResponse) => {
      onCompleted(accessToken);
    },
    [onCompleted]
  );

  const handleOnError = useCallback(
    (error: string) => {
      console.error("[Instagram Facebook connect]", error);
      onError?.(error);
    },
    [onError]
  );

  if (!APP_ID) {
    return (
      <button type="button" className={className} disabled>
        {children}
      </button>
    );
  }

  return (
    <FacebookProvider version="v21.0" appId={APP_ID}>
      <Login
        scope={SCOPE}
        onCompleted={handleOnCompleted}
        onError={handleOnError}
      >
        {({ handleClick }: { handleClick: () => void }) => (
          <button type="button" className={className} onClick={handleClick}>
            {children}
          </button>
        )}
      </Login>
    </FacebookProvider>
  );
}
